import { gsap } from 'gsap';

const svgIonDirectory = (element) => {
  /* default fill #DED6C7 */
  let sectionContainer = element;
  let mapContainer = element.querySelector(".section-container-svg");
  // let mapSvg = element.querySelector(".map-svg-directory");
  let tabSelect = element.querySelector(".block-buttons").querySelectorAll(".secondary-button");
  let zoomButtons = element.querySelectorAll('.zoom');

  let fullScreenButton = element.querySelector('.button-full-screen');

  let allLevels = element.querySelector('.all-levels-floorplan');
  let levels = element.querySelectorAll('.level-floorplan');
  let svgLevels = element.querySelectorAll('.floors-svg svg .level');
  let allImgs = element.querySelectorAll('.floor-plans img');
  let activeImg = element.querySelector('.floor-plans img.active')
  let activeSvgLvl = element.querySelector('.floors-svg svg .level');

  let tenantsList = element.querySelector('.section-map-places');
  let nones = element.querySelectorAll('.section-map-places li.none')
  let tenants = element.querySelectorAll('.section-map-places li:not(.none)')
  let tenantsUl = element.querySelectorAll('.tenants-ul')


  let initialZoom = 1;
  const maxZoom = 2;

  //zoom in zoom out
  zoomButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      const activeImg = element.querySelector('.floor-plans .active');
      if (button.classList.contains('button-zoom-in')) {
        gsap.to(activeImg, {
          scale: () => {
            return initialZoom >= maxZoom ? maxZoom : initialZoom += 0.1
          }
        })
        if(initialZoom >= maxZoom){
          button.setAttribute('disabled', true);
        }
      } else {
        gsap.to(activeImg, {
          scale: () => {
            return initialZoom <= 1 ? initialZoom : initialZoom -= 0.1
          }
        })
        element.querySelector('.zoom.button-zoom-in').removeAttribute('disabled');
      }
    })

  });


  //panning

  mapContainer.addEventListener('mousemove', (e) => {
    if (initialZoom > 1 ) {
      const activeImg = element.querySelector('.floor-plans .active');

      const { width, height } = activeImg.getBoundingClientRect()
      const containerWidth = mapContainer.getBoundingClientRect().width;
      const containerHeight = mapContainer.getBoundingClientRect().height;

      const moveOffsetX = (width - containerWidth) / 2;
      const moveOffsetY = (height - containerHeight) / 2;

      const x = e.offsetX - (containerWidth / 2);
      const y = e.offsetY - (containerHeight / 2);

      gsap.to(activeImg, {
        x: () => {
          if (Math.abs(x) < moveOffsetX) {
            return -x
          }
        },
        y: () => {
          if (Math.abs(y) < moveOffsetY) {
            return -y
          }
        }
      })

    }
  })

  mapContainer.addEventListener('mouseleave', () => {
    const activeImg = element.querySelector('.floor-plans .active');
    gsap.to(activeImg, {
      x: 0,
      y: 0
    })
  })

  // fullScreenButton

  fullScreenButton.addEventListener('click', () => {
    sectionContainer.classList.toggle('fullscreen');
  })

  // scroll
  allImgs.forEach(img => {
    img.addEventListener('click', ()=>{
      gsap.to(window, {
        duration: 0.4,
        scrollTo: {
          y: tenantsList,
          offsetY: () => window.innerHeight/3, 
        }
      })
    })
  })



  tabSelect.forEach(button => {
    button.addEventListener('click', buttonClicks(button))
  });

  svgLevels.forEach(button => {
    button.addEventListener('click', buttonClicks(button))
  });

  function buttonClicks(button) {
    return () => {
      const control = button.getAttribute('aria-controls');

      svgLevels.forEach(tab => {
        tab.ariaSelected = "false"
      })
      tabSelect.forEach(tab => {
        tab.ariaSelected = "false"
      })

      activeImg.classList.remove('active');

      if(control != 'all'){
        element.querySelector(`.floors-svg svg .level[aria-controls="${control}"]`).ariaSelected = "true"
      }

      element.querySelector(`.block-buttons .secondary-button[aria-controls="${control}"]`).ariaSelected = "true"


      switch (control) {
        case 'all':
          activeImg = allLevels;
          allLevels.classList.add('active')
          assignActive(0, control)
          break;
        case 'll':
          assignActive(0, control)
          break;
        case 'l1':
          assignActive(1, control)
          break;
        case 'l2':
          assignActive(2, control)
          break;
        case 'l3':
          assignActive(3, control)
          break;
        case 'l4':
          assignActive(4, control)
          break;
        case 'l5':
          assignActive(5, control)
          break;
        default:
          break;
      }
    }
  }

  function assignActive(index, lvl) {
    nones.forEach(none => {
      none.classList.remove('show');
    })

    if(lvl == 'all'){
      gsap.set(tenants, {display: 'list-item'});
      return;
    }
    activeImg = levels[index];
    activeSvgLvl = svgLevels[index];
    levels[index].classList.add('active')
    svgLevels[index].classList.add('active')

    gsap.set(tenants, {display: 'list-item'});

    tenants.forEach(tenant => {
      if(!tenant.classList.contains(lvl)){
        gsap.set(tenant, {display: 'none'});
      }
    })

    tenantsUl.forEach(list => {
      const children =  list.querySelectorAll('.tenant');
      const noneDom = list.querySelector('.none');
      let hiddenChildren = [];


      children.forEach(child => {
        if (child.style.display == 'none'){
          hiddenChildren.push(child);
        }
      })

      if(hiddenChildren.length == children.length){
        noneDom.classList.add('show');
      }

    })
  }


};

export { svgIonDirectory };
